// @flow
import React from "react"
import withMutation from "hoc/withMutation"
import { compose, type HOC } from "recompose"
import withForm from "forms/withForm"
import { stringRequired, password } from "forms/validators/string"
import {
  FixedBottom,
  FixedBottomSpacer,
} from "componentsStyled/Layout/FixedBottom"
import withConnect from "hoc/withConnect"
import { notificationSuccess } from "data/notifications/actions"
import { WrapNoDesktop } from "componentsStyled/Layout/Wrap"
import { changePasswordMutation } from "data/auth/graphql/mutations"
import Button from "components/Button"
import Alert from "forms/Alert"
import { constructGraphqlError } from "common/graphql/errors"
import TextInput from "forms/Input/Text"

const ChangePasswordForm = ({ isSubmitting, error = "" }) => (
  <React.Fragment>
    <WrapNoDesktop>
      <Alert>{error}</Alert>
      <TextInput
        name="oldPassword"
        label="Old Password"
        type="password"
        placeholder="Old password"
      />
      <TextInput
        name="password"
        label="Password"
        type="password"
        placeholder="New password"
      />
      <TextInput
        name="passwordAgain"
        label="Confirm Password"
        type="password"
        placeholder="Confirm password"
      />
    </WrapNoDesktop>
    <FixedBottomSpacer />
    <FixedBottom>
      <Button loading={isSubmitting} fullwidth>
        Save
      </Button>
    </FixedBottom>
  </React.Fragment>
)

const schema = {
  oldPassword: stringRequired,
  password: password,
  passwordAgain: password,
}

const mapDispatchToProps = {
  notificationSuccess,
}

const enhancer: HOC<*, {||}> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withMutation(changePasswordMutation),
  withForm({
    schema,
    onSubmit: props => v => {
      if (v.password !== v.passwordAgain) {
        return constructGraphqlError("Passwords must be same")
      }
      return props.submitMutation({
        oldPassword: v.oldPassword,
        password: v.password,
      })
    },
    onSuccess: props => () => props.notificationSuccess("Successfully changed"),
  }),
)

export default enhancer(ChangePasswordForm)



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/Subpages/ChangePassword/ChangePasswordForm/index.js